import client from '../../shared/api/client';
import { Role, PermissionGroup } from '../../shared/types';

export const getRoles = async (): Promise<Role[]> => {
  const response = await client.get<Role[]>('/roles');
  return response.data;
};

export const getRole = async (id: number): Promise<Role> => {
  const response = await client.get<Role>(`/roles/${id}`);
  return response.data;
};

export const createRole = async (data: { name: string; description?: string; permissions?: number[] }): Promise<Role> => {
  const response = await client.post<Role>('/roles', data);
  return response.data;
};

export const updateRole = async (id: number, data: { name?: string; description?: string; permissions?: number[] }): Promise<Role> => {
  const response = await client.put<Role>(`/roles/${id}`, data);
  return response.data;
};

export const deleteRole = async (id: number): Promise<void> => {
  await client.delete(`/roles/${id}`);
};

export const getPermissions = async (): Promise<PermissionGroup[]> => {
  const response = await client.get<PermissionGroup[]>('/roles/permissions');
  return response.data;
};

export const syncRolePermissions = async (roleId: number, permissionIds: number[]): Promise<Role> => {
  const response = await client.put<Role>(`/roles/${roleId}/permissions`, { permissions: permissionIds });
  return response.data;
};

export const assignAdminsToRole = async (roleId: number, adminIds: number[]): Promise<Role> => {
  const response = await client.post<Role>(`/roles/${roleId}/admins`, { admin_ids: adminIds });
  return response.data;
};

export const removeAdminFromRole = async (roleId: number, adminId: number): Promise<void> => {
  await client.delete(`/roles/${roleId}/admins/${adminId}`);
};

export const getAdminRoles = async (adminId: number): Promise<{ admin: { id: number; name: string; email: string }; roles: Role[]; permissions: string[] }> => {
  const response = await client.get(`/admins/${adminId}/roles`);
  return response.data;
};

export const syncAdminRoles = async (adminId: number, roleIds: number[]): Promise<void> => {
  await client.put(`/admins/${adminId}/roles`, { role_ids: roleIds });
};

export interface ProvisionAdminPayload {
  id?: number;
  email: string;
  name: string;
  password?: string;
  role_ids?: number[];
}

export interface ProvisionAdminResponse {
  admin: {
    id: number;
    name: string;
    email: string;
    role: string;
    backoffice_role: string;
    is_active: boolean;
    roles: Array<{ id: number; name: string; slug: string }>;
  };
  created: boolean;
}

export const provisionAdmin = async (
  payload: ProvisionAdminPayload,
): Promise<ProvisionAdminResponse> => {
  const response = await client.post<ProvisionAdminResponse>('/admins/provision', payload);
  return response.data;
};
